<template>
  <div class="search-container">
    <div class="search-tabs">
      <div
        class="search-tab"
        v-for="item in options"
        :key="item.value"
        :class="{ active: value === item.value, disabled: !!item.disabled }"
        @click="searchChange(item.value, !!item.disabled)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
  },
  computed: {
    options() {
      return [
        {
          label: this.$l('search_tab_track') || '跟踪记录',
          value: 'Track',
        },
        {
          label: this.$l('search_tab_quotation') || '报价记录',
          value: 'Quotation',
        },
        {
          label: this.$l('search_tab_product_proofing') || '产品打样',
          value: 'ProductProofing',
        },
        {
          label: this.$l('search_tab_fabric_proofing') || '面料打样',
          value: 'FabricProofing',
        },
        {
          label: this.$l('search_tab_sample_sending') || '寄样记录',
          value: 'SampleSending',
        },
        {
          label: this.$l('search_tab_product_testing') || '产品测试',
          value: 'ProductTesting',
        },
        {
          label: this.$l('search_tab_order_confirmation') || '下单确认',
          value: 'OrderConfirmation',
        },
        {
          label: this.$l('search_tab_picture_document') || '图片文档',
          value: 'PictureDocument',
        },
      ]
    },
  },
  methods: {
    searchChange(value, disabled) {
      if (disabled) {
        return
      }
      this.$emit('update:value', value)
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.search-container {
  .search-tabs {
    display: flex;
    align-items: center;
    .search-tab {
      font-size: 14px;
      line-height: 28px;
      padding: 0px 0px 12px 0px;
      margin-right: 45px;
      color: #2e2e2e;
      border-bottom: 3px solid transparent;
      cursor: pointer;
      width: max-content;
      .badge {
        margin-left: 5px;
        font-weight: 400;
        color: #707070;
        background-color: rgba(0, 0, 0, 0.07);
        padding: 3px 7px;
        font-size: 12px;
        border-radius: 10px;
      }
    }
    .search-tab:hover {
      color: #007bff;
      border-bottom-color: rgba(0, 0, 0, 0.1);
    }
    .search-tab.active {
      color: #007bff;
      font-weight: 600;
      border-bottom-color: #007bff;
      .badge {
        font-weight: 600;
      }
    }
    .search-tab.disabled {
      color: #2e2e2e !important;
      border-bottom: 3px solid transparent !important;
      cursor: not-allowed;
    }
  }
}
</style>
